/* tslint:disable */

export class ErrorMessage {
		Message: string;
		Code: string;
		ViewModelValues: string;

}



// WEBPACK FOOTER //
// D:/a/1/s/src/services/generated/models/ErrorMessage.ts